import { render, staticRenderFns } from "./AddMenuCatalog.vue?vue&type=template&id=6dbeb264&scoped=true"
import script from "./AddMenuCatalog.vue?vue&type=script&lang=js"
export * from "./AddMenuCatalog.vue?vue&type=script&lang=js"
import style0 from "./AddMenuCatalog.vue?vue&type=style&index=0&id=6dbeb264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbeb264",
  null
  
)

export default component.exports